import { useField, useForm } from 'react-final-form';

import { SimpleVehicleLookUp } from 'components/Toolkit/SimpleVehicleLookUp/SimpleVehicleLookUp';

import { formatTradeInValuesForDisplay } from 'helpers/formatting';
import { useOnUpdateOnly } from 'hooks/UseOnUpdateOnly';
import { MILEAGE_UNIT } from 'types';
import {
  FORM_VALUES,
  IEnquiryData,
  VehicleLookUpData,
} from 'components/PageWrappers/AdDetails/components/DealerEnquiryModal/DealerEnquiryModal.config';
import type { RefObject } from 'react';

interface ITradeInManager {
  setTradeInValues: (t?: VehicleLookUpData) => void;
  tradeInValues?: VehicleLookUpData;
  setDisableVehicleRegLookupButton: (t: boolean) => void;
  resultsRef?: RefObject<HTMLDivElement>;
  onVehicleLookUpInputCallback: (t: string) => void;
  disableVehicleRegLookupButton?: boolean;
  errorMessage?: string;
  setErrorMessage: (t?: string) => void;
}

function TradeInManager({
  setTradeInValues,
  tradeInValues,
  setDisableVehicleRegLookupButton,
  onVehicleLookUpInputCallback,
  resultsRef,
  disableVehicleRegLookupButton,
  errorMessage,
  setErrorMessage,
}: ITradeInManager) {
  const vehicleTradeIn = useField(FORM_VALUES.VEHICLE_TRADE_IN).input.value;
  const registrationNo = useField(FORM_VALUES.REGISTRATION_NO).input.value;
  const { change, batch } = useForm<IEnquiryData>();

  function resetModalOnCheckboxChange() {
    if (!vehicleTradeIn && tradeInValues) {
      batch(() => {
        change(FORM_VALUES.REGISTRATION_NO, '');
        change(FORM_VALUES.MILEAGE, '');
        change(FORM_VALUES.MILEAGE_UNIT, MILEAGE_UNIT.KILOMETRES);
      });
    }
  }

  function resetLookupDataOnRegChange() {
    if (tradeInValues) {
      batch(() => {
        change(FORM_VALUES.MILEAGE, '');
        change(FORM_VALUES.MILEAGE_UNIT, MILEAGE_UNIT.KILOMETRES);
      });
    }
  }

  useOnUpdateOnly(() => {
    resetModalOnCheckboxChange();
    setDisableVehicleRegLookupButton(false);
  }, [vehicleTradeIn]);

  useOnUpdateOnly(() => {
    resetLookupDataOnRegChange();
    setDisableVehicleRegLookupButton(false);
  }, [registrationNo]);

  useOnUpdateOnly(() => {
    setTradeInValues(undefined);
    setErrorMessage(undefined);
  }, [registrationNo, vehicleTradeIn]);

  return (
    <div ref={resultsRef}>
      <SimpleVehicleLookUp
        onVehicleLookUpInputCallback={onVehicleLookUpInputCallback}
        errorMessage={errorMessage}
        displayAttributes={formatTradeInValuesForDisplay(tradeInValues)}
        buttonText="Find"
        disableVehicleRegLookupButton={disableVehicleRegLookupButton}
      />
    </div>
  );
}

export { TradeInManager };
